(ns ui.window
  "The size of the browser window, kept in the app db. `::track-window-size` starts the
   tracking, and each app dispatches it once when it starts. `::window-size` is the
   subscription: a map with `:width` and `:height` in pixels, or nil before the tracking has
   started. A view that depends on the size of the window reads the subscription, and does
   not add a listener of its own."
  (:require
   [re-frame.core :as rf]
   [ui.dom-globals :as dg]))

(defonce resize-listener*
  (atom nil))

(rf/reg-cofx
 ::current-window-size
 (fn [cofx _]
   (assoc cofx :window-size {:width  (dg/window-inner-width)
                             :height (dg/window-inner-height)})))

(rf/reg-sub
 ::window-size
 (fn [db]
   (get db ::window-size)))

(defn resized-fx
  "The effects of a resize: the new size goes to the app db."
  [{:keys [db window-size]}]
  {:db (assoc db ::window-size window-size)})

(rf/reg-event-fx
 ::on-window-resize
 [(rf/inject-cofx ::current-window-size)]
 (fn [cofx _]
   (resized-fx cofx)))

(defn listen-resize!
  "Add the listener of the window resize, once. A second call does nothing."
  []
  (when-not @resize-listener*
    (let [listener (fn [_]
                     (rf/dispatch [::on-window-resize]))]
      (reset! resize-listener* listener)
      (dg/add-event-listener! (dg/window) "resize" listener))))

(rf/reg-fx
 ::listen-resize
 (fn [_]
   (listen-resize!)))

(defn track-fx
  "The effects that start the tracking: add the listener, and store the size now."
  []
  {::listen-resize true
   :dispatch       [::on-window-resize]})

(rf/reg-event-fx
 ::track-window-size
 (fn [_ _]
   (track-fx)))
